<template>
	<div class="position-relative" style="z-index: 1037">
    <div class="row no-gutters justify-content-center">
      <div class="fixed-bottom d-block nav-bottom" style="bottom:0px;top: 0">
        <div class="custom-container-fluid px-0" style="box-shadow: 1px 0px 6px 2px #dfdfdf4f">
          <div class="row justify-content-center no-gutters">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
              <div class="container px-4 pt-3 bg-white box-shadow-main">
                <div class="pb-2">
                  <img src="../../../../assets/img/icon/close.png" class="my-2 d-inline-block mr-2 cursor-pointer" width="15" @click="close()">
                  <p class="mb-0 body-2-2 text-16 font-bold d-inline-block">{{head_text}}</p>
                </div>
                <div class="pb-4 scroll-hide-mobile popup-scroll-body" style="height: 95vh">
                  <p class="mb-4 mt-2 body-2-2 font-regular">{{$t('hotel.visitor-detail.please-fill')}}</p>
                  <form>
                    <div class="my-3">
                      <p 
                      	class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" 
                      	v-show="show_label.title" 
                      	:class="{'label-active':show_label.title}">
                      	Title
                      </p>
                      <v-select 
                      	class="general-select-border body-2-2 text-14 mb-1" 
                      	:placeholder="$t('hotel.visitor-detail.title')" 
                      	:clearable="false"
                      	@focus="toggleLabel('focus', 'title')" 
                      	@blur="toggleLabel('blur', 'title')" 
                      	:options="options_title" 
                      	v-model="form.title"></v-select>
                      <p class="mb-0 body-2 font-regular text-12 sub-label">{{$t('hotel.visitor-detail.title')}}</p>
                    </div>
                    <div class="my-3">
                      <div class="row slim-grid-row">
                        <div class="col-6">
                          <p 
                          	class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" v-show="show_label.first_name" 
                          	:class="{'label-active':show_label.first_name}">{{$t('hotel.visitor-detail.first-name')}}</p>
                          <input 
                          	type="text" 
                          	class="form-control body-2-2 text-14 mb-1" 
                          	:placeholder="$t('hotel.visitor-detail.first-name')" 
                          	@focus="toggleLabel('focus','first_name')" 
                          	@blur="toggleLabel('blur','first_name')" 
                          	v-model="form.first_name">
                        </div>
                        <div class="col-6">
                          <p 
                          	class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" v-show="show_label.last_name" 
                          	:class="{'label-active':show_label.last_name}">{{$t('hotel.visitor-detail.last-name')}}</p>
                          <input 
                          	type="text" 
                          	class="form-control body-2-2 text-14 mb-1" 
                          	:placeholder="$t('hotel.visitor-detail.last-name')" 
                          	@focus="toggleLabel('focus','last_name')" 
                          	@blur="toggleLabel('blur','last_name')" 
                          	v-model="form.last_name">
                        </div>
                        <div class="col-12">
                        <p class="mb-0 body-2 font-regular text-12 sub-label">{{$t('hotel.visitor-detail.name-desc')}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="my-3">
                      <div class="row slim-grid-row">
                        <div class="col-6">
                          <p 
                          	class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" v-show="show_label.dial_code" 
                          	:class="{'label-active':show_label.dial_code}">{{$t('hotel.visitor-detail.country-code')}}</p>
                          <v-select 
                          	class="general-select-border body-2-2 text-14 mb-1" 
                          	:placeholder="$t('hotel.visitor-detail.country-code')" 
                          	label="dial_code"
                          	:clearable="false"
                          	@focus="toggleLabel('focus','dial_code')" 
                          	@blur="toggleLabel('blur','dial_code')" 
                          	:options="country" 
                          	v-model="dial_code">
                          	<template #option="{ dial_code, code }">
															<span class="body-2 mb-0">{{code}} </span>|<span class="body-2 text-color-dark"> {{dial_code}}</span>
														</template>
                          </v-select>
                          <p class="mb-0 body-2 font-regular text-12 sub-label">{{$t('hotel.visitor-detail.country-code')}}</p>
                        </div>
                        <div class="col-6">
                          <p 
                          	class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" v-show="show_label.phone_number" 
                          	:class="{'label-active':show_label.phone_number}">{{$t('hotel.visitor-detail.phone-number')}}</p>
                          <input 
                          	type="text" 
                          	class="form-control body-2-2 text-14 mb-1" 
                          	:placeholder="$t('hotel.visitor-detail.phone-number')" 
                          	@focus="toggleLabel('focus','phone_number')" 
                          	@blur="toggleLabel('blur','phone_number')" 
                          	v-model="form.phone_number">
                          <p v-if="error.phone == ''" class="mb-0 body-2 font-regular text-12 sub-label">{{$t('hotel.visitor-detail.phone-number')}}</p>
                          <p class="mb-0 body-2 font-regular text-12 text-danger" v-else>{{error.phone}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="my-3">
                      <div class="row slim-grid-row">
                        <div class="col-12">
                          <p 
                          	class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" v-show="show_label.email" 
                          	:class="{'label-active':show_label.email}">{{$t('hotel.visitor-detail.email')}}</p>
                          <input 
                          	type="email" 
                          	class="form-control body-2-2 text-14 mb-1" 
                          	:placeholder="$t('hotel.visitor-detail.email')" 
                          	@focus="toggleLabel('focus','email')" 
                          	@blur="toggleLabel('blur','email')" 
                          	v-model="form.email">
                            <p class="mb-0 text-danger body-2 text-12 font-regular delay" v-if="!validationEmail && show_label.email">{{$t('hotel.visitor-detail.email-warning')}}</p>
                            <p class="mb-0 body-2 font-regular text-12 sub-label" v-else>{{$t('hotel.visitor-detail.email-desc')}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="mt-3">
                      <div class="row slim-grid-row">
                        <div class="col-12 mb-3">
                          <p 
                          	class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" v-show="show_label.country" 
                          	:class="{'label-active':show_label.country}">{{$t('hotel.visitor-detail.country')}}</p>
                          <v-select 
                            class="general-select-border body-2-2 text-14 mb-1" 
                            :placeholder="$t('hotel.visitor-detail.country')" 
                            label="name"
                            :clearable="false"
                            @focus="toggleLabel('focus','country')" 
                            @blur="toggleLabel('blur','country')" 
                            :options="country" 
                            v-model="country_selected">
                          </v-select>
                          <!-- <input 
                          	type="text" 
                          	class="form-control body-2-2 text-14 mb-1" 
                          	:placeholder="$t('hotel.visitor-detail.country')" 
                          	@focus="toggleLabel('focus','country')" 
                          	@blur="toggleLabel('blur','country')" 
                          	v-model="form.country">
                          <p class="mb-0 body-2 font-regular text-12 sub-label">{{$t('hotel.visitor-detail.country')}}</p> -->
                        </div>
                      </div>
                    </div>
                    <!-- <div class="mb-3">
                      <div class="row slim-grid-row">
                        <div class="col-12 mb-3">
                          <p 
                            class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" v-show="show_label.address" 
                            :class="{'label-active':show_label.address}">{{$t('hotel.visitor-detail.address')}}</p>
                          <textarea 
                            rows="3" 
                            type="text" 
                            class="form-control body-2-2 text-14 mb-1" 
                            :placeholder="$t('hotel.visitor-detail.address')" 
                            @focus="toggleLabel('focus','address')" 
                            @blur="toggleLabel('blur','address')" 
                            v-model="form.address">
                          </textarea>
                          <p class="mb-0 body-2 font-regular text-12 sub-label">{{$t('hotel.visitor-detail.address')}}</p>
                        </div>
                      </div>
                    </div> -->
                  </form>
                  <button 
                  	type="button" 
                  	:disabled="is_form_valid || !validationEmail" 
                  	class="button-primary w-100 mb-1" 
                  	@click="submit()"
                  	:class="{'button-disabled': is_form_valid || !validationEmail}">{{$t('general.save')}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	import country from "@/data/country"
	import {mapGetters,mapMutations} from 'vuex';
	import { parsePhoneNumber,parsePhoneNumberFromString,ParseError  } from 'libphonenumber-js'
  import {formatEmailValidation} from '@/utils/index.js'

	export default{
    components:{
      formatEmailValidation
    },
		props:{
			type: {
				type: String,
				default: 'customer'
			}
		},
		data(){
			return{
				country: country,
				show_label: {
          first_name: false,
          last_name: false,
          phone_number: false,
          title: false,
          country_code: false,
          email: false,
          dial_code: false,
          country: false
        },
        form: {
          first_name: "",
	        last_name: "",
	        phone_number: "",
	        email: "",
	        title: "Mr",
          country: ""
        },
        error:{
        	phone: ''
        },
        dial_code: {},
        country_selected: {},
        options_title: ['Mr',"Mrs","Ms"]
			}
		},
		mounted(){
			this.fillData()
			for(let label in this.show_label){
				this.toggleLabel("blur",label)
			}
		},
		computed:{
			data(){
				return (this.type == 'customer') ? this.getBeCart().customer_details : this.getBeCart().visitor_details
			},
			head_text(){
				return (this.type == 'customer') ? 'Contact Detail' : 'Visitor Detail'
			},
			is_form_valid(){
				return (this.form.first_name != '' && this.form.email != '' && this.form.phone_number != '') ? false : true
			},
      validationEmail(){
        return formatEmailValidation(this.form.email) ? true : false
      }
		},
		methods:{
			...mapGetters(['getBeCart','getIsCartContactEmail']),
			...mapMutations(['setBeCustomer','setBeVisitor']),
			fillData(){
				this.form = Object.assign({}, this.data)
				if (this.data.phone_number == '#' || this.data.phone_number == '' || this.data.phone_number == undefined || this.data.phone_number == null) {
					this.form.phone_number = ''
	    		this.dial_code = this.country.find(x => x.code == 'ID')
				}else{
					const phone_parsed = parsePhoneNumberFromString(this.data.phone_number)
					if (phone_parsed == undefined || typeof(phone_parsed) == 'undefined') {
		    		this.error.phone = this.$t("hotel.visitor-detail.Your phone number") +' ('+this.data.phone_number+') '+ this.$t("hotel.visitor-detail.is invalid")
		    		this.dial_code = this.country.find(x => x.code == 'ID')
					}else{
						this.dial_code = this.country.find(x => x.code == phone_parsed.country)
						this.form.phone_number = phone_parsed.nationalNumber
					}
				}

        let params_country = this.form.country == '' ? 'Indonesia' : this.form.country
        this.country_selected = this.country.find(x=>x.name == params_country)
			},
			close(){
				this.$emit("close",'close')
			},
			toggleLabel(data, id){
        if (data == 'focus') {
          this.show_label[id] = true  
        }else{
        	if(id == 'dial_code'){
        		this.show_label[id] = (Object.keys(this.dial_code).length == 0) ? false :  true
        	}else if(id == 'country'){
            this.show_label[id] = (Object.keys(this.country_selected).length == 0) ? false :  true
          }else{
          	this.show_label[id] = (this.form[id] == '') ? false :  true 
        	}
        }
      },
      submit(){
        this.form.country = this.country_selected.name
      	let params = Object.assign({}, this.form)
      	if(this.form.phone_number != ''){
    			params.phone_number = this.dial_code.dial_code+this.form.phone_number
    		}
    		if(this.type == 'customer'){

    			this.setBeCustomer(params)
    		}else{
    			this.setBeVisitor(params)
    		}
    		this.close()
      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/mobile/cartContactDetail.vue